// modules
import { createAction } from 'redux-actions'

// actions
export const setPatientEventsReport = createAction('SET_PATIENT_EVENTS_REPORT')
export const setPatientEventsReportLoading = createAction(
  'SET_PATIENT_EVENTS_REPORT_LOADING'
)
